const INPUT_NAME = 'recaptcha_token';

class CaptchaProtectedFormComponent extends HTMLElement {
  get form() {
    return this.querySelector('form');
  }

  get submitButtons() {
    return this.querySelectorAll('form button[type=submit]');
  }

  get recaptchaTokenInput() {
    return this.querySelector(`form input[name=${INPUT_NAME}]`);
  }

  get recaptchaSiteKey() {
    return this.dataset.recaptchaSiteKey;
  }

  get action() {
    return this.dataset.action;
  }

  connectedCallback() {
    this.submitButtons.forEach((button) => {
      button.addEventListener('click', this.captureSubmit.bind(this, button));
    });
  }

  captureSubmit(button, event) {
    event.preventDefault();

    if (grecaptcha) {
      grecaptcha.ready(() => {
        grecaptcha
          .execute(this.recaptchaSiteKey, { action: this.action })
          .then((token) => {
            this.findOrCreateCaptchaInput().value = token;
            this.form.requestSubmit(button);
          });
      });
    } else {
      this.form.requestSubmit();
    }
  }

  findOrCreateCaptchaInput() {
    if (!this.recaptchaTokenInput) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = INPUT_NAME;
      this.form.appendChild(input);
    }

    return this.recaptchaTokenInput;
  }
}

if (!window.customElements.get('tmp-captcha-protected-form')) {
  window.CaptchaProtectedFormComponent = CaptchaProtectedFormComponent;
  window.customElements.define(
    'tmp-captcha-protected-form',
    CaptchaProtectedFormComponent
  );
}
